const Qs = require("qs");
const Crypto = require("crypto");

module.exports.hash = (params) =>
  Crypto.createHash("sha256")
    .update(
      Qs.stringify(params, { sort: (a, b) => a.localeCompare(b) }),
      "utf8"
    )
    .digest("hex");

module.exports.formatDate = (date) =>
  new Date(date).toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "Europe/Berlin",
  });
